import { commonRoutes } from "../components/shared/commonConstants";

const storageKey = "redirectUrl";

export const redirectUrl = {
    get: () => sessionStorage.getItem(storageKey),
    set: (url: string) => {
        if (url &&
            (url.trim() !== "" || url.trim() !== commonRoutes.home ||
                url.trim().toLowerCase() !== commonRoutes.landing.toLowerCase())) {
            sessionStorage.setItem(storageKey, url);
        }
    },
    remove: () => sessionStorage.removeItem(storageKey)
}

export default redirectUrl
